import { useState } from "react";
import { STRIPE_PAYMENT_LINK, DONATION_AMOUNTS, COLORS } from "../config";

export default function DonatePage() {
  const [sel, setSel]       = useState(1);
  const [custom, setCustom] = useState("");
  const [name, setName]     = useState("");

  const handleDonate = () => {
    window.open(STRIPE_PAYMENT_LINK, "_blank", "noopener,noreferrer");
  };

  const displayAmount = custom ? `£${custom}` : DONATION_AMOUNTS[sel]?.label;

  return (
    <div style={{ background: COLORS.bg, minHeight:"100vh" }}>

      {/* Header — left-aligned, no gradient */}
      <div style={{ maxWidth:"520px", margin:"0 auto", padding:"clamp(40px,8vw,64px) 20px 0" }}>
        <div style={{ fontSize:"0.6875rem", fontWeight:600, color: COLORS.primary, letterSpacing:"0.05em", textTransform:"uppercase", marginBottom:"8px" }}>Support</div>
        <h1 style={{ margin:"0 0 12px", fontSize:"clamp(1.75rem,5vw,2.5rem)", fontWeight:800, color: COLORS.textPrimary, letterSpacing:"-0.02em", lineHeight:1.1 }}>
          Support tamizh.fun
        </h1>
        <p style={{ margin:"0 0 40px", fontSize:"1rem", color: COLORS.textSecondary, lineHeight:1.7 }}>
          tamizh.fun is free for every family, forever. Your donation funds the research, word data, and keeps it ad-free.
        </p>
      </div>

      <div style={{ maxWidth:"520px", margin:"0 auto", padding:"0 20px 64px" }}>

        {/* VIRAT context — no card, just content */}
        <div style={{ display:"flex", gap:"16px", alignItems:"flex-start", marginBottom:"32px", paddingBottom:"24px", borderBottom:`1px solid ${COLORS.border}` }}>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:"0.875rem", fontWeight:700, color: COLORS.textPrimary, marginBottom:"4px" }}>VIRAT UK Charity</div>
            <div style={{ fontSize:"0.8125rem", color: COLORS.textMuted, lineHeight:1.6 }}>
              Donations support VIRAT UK's mission to preserve Indian heritage for the UK diaspora. Gift Aid eligible.
            </div>
            <a href="https://virat.org.uk" target="_blank" rel="noopener noreferrer"
              style={{ fontSize:"0.75rem", color: COLORS.primary, fontWeight:600 }}>
              virat.org.uk
            </a>
          </div>
        </div>

        {/* Amount selector */}
        <div style={{ marginBottom:"24px" }}>
          <div style={{ fontSize:"0.6875rem", fontWeight:600, color: COLORS.textMuted, marginBottom:"12px", textTransform:"uppercase", letterSpacing:"0.05em" }}>
            Choose amount
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:"8px", marginBottom:"12px" }}>
            {DONATION_AMOUNTS.map((a, i) => (
              <button key={i} onClick={() => { setSel(i); setCustom(""); }} style={{
                padding:"16px 12px", borderRadius:"12px", cursor:"pointer", textAlign:"center",
                border: sel===i && !custom ? `2px solid ${COLORS.primary}` : "2px solid transparent",
                background: sel===i && !custom ? COLORS.primaryLight : COLORS.bgAlt,
                transition:"all 0.2s cubic-bezier(0.16,1,0.3,1)",
              }}>
                <div style={{ fontSize:"1.25rem", fontWeight:800, color: COLORS.primary }}>{a.label}</div>
                <div style={{ fontSize:"0.6875rem", color: COLORS.textMuted, marginTop:"2px" }}>{a.sublabel}</div>
              </button>
            ))}
          </div>

          {/* Custom */}
          <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
            <span style={{ fontSize:"1.125rem", fontWeight:700, color: COLORS.textMuted }}>£</span>
            <input value={custom}
              onChange={e => { setCustom(e.target.value.replace(/\D/g, "")); if (e.target.value) setSel(-1); }}
              placeholder="Other amount"
              style={{
                flex:1, padding:"12px 16px", borderRadius:"10px",
                border:`1.5px solid ${custom ? COLORS.primary : COLORS.border}`,
                background:"transparent", color: COLORS.textPrimary,
                fontSize:"1rem", outline:"none",
              }} />
          </div>
        </div>

        {/* Name */}
        <input value={name} onChange={e => setName(e.target.value)}
          placeholder="Your name (optional)"
          style={{
            width:"100%", padding:"12px 16px", borderRadius:"10px",
            border:`1.5px solid ${COLORS.border}`, background:"transparent",
            color: COLORS.textPrimary, fontSize:"0.875rem", outline:"none",
            boxSizing:"border-box", marginBottom:"20px",
          }} />

        {/* Donate button */}
        <button onClick={handleDonate} style={{
          width:"100%", padding:"16px", borderRadius:"12px",
          background: COLORS.primary, border:"none", color:"#fff", fontWeight:700,
          fontSize:"1rem", cursor:"pointer",
          transition:"transform 0.15s cubic-bezier(0.16,1,0.3,1)",
        }}
        onMouseDown={e => e.currentTarget.style.transform='scale(0.98)'}
        onMouseUp={e => e.currentTarget.style.transform='scale(1)'}
        onMouseLeave={e => e.currentTarget.style.transform='scale(1)'}>
          Donate {displayAmount} via Stripe
        </button>

        <div style={{ textAlign:"center", marginTop:"10px", fontSize:"0.6875rem", color: COLORS.textMuted }}>
          Secured by Stripe · No account needed · VIRAT UK Charity
        </div>

        {/* Impact — no cards, just clean list */}
        <div style={{ marginTop:"32px", paddingTop:"24px", borderTop:`1px solid ${COLORS.border}` }}>
          <div style={{ fontSize:"0.6875rem", fontWeight:600, color: COLORS.textMuted, marginBottom:"16px", textTransform:"uppercase", letterSpacing:"0.05em" }}>
            What your donation funds
          </div>
          {[
            ["£5",  "1 month of learning for one child"],
            ["£10", "Corpus analysis of 10 Tamil texts"],
            ["£25", "New word sets for Telugu or Kannada"],
            ["£50", "Audio pronunciation for all 81 words"],
          ].map(([amt, desc]) => (
            <div key={amt} style={{
              display:"flex", gap:"16px", alignItems:"center",
              padding:"12px 0", borderBottom:`1px solid ${COLORS.border}`,
            }}>
              <div style={{ fontWeight:700, color: COLORS.primary, minWidth:"36px", fontSize:"0.875rem" }}>{amt}</div>
              <div style={{ fontSize:"0.875rem", color: COLORS.textPrimary }}>{desc}</div>
            </div>
          ))}
        </div>

        {/* Languages pipeline */}
        <div style={{ marginTop:"32px" }}>
          <div style={{ fontSize:"0.6875rem", fontWeight:600, color: COLORS.textMuted, marginBottom:"12px", textTransform:"uppercase", letterSpacing:"0.05em" }}>
            Languages in pipeline
          </div>
          {[
            ["Tamil",   "Available now",   true  ],
            ["Telugu",  "Coming soon",     false ],
            ["Kannada", "Coming soon",     false ],
          ].map(([lang, status, live]) => (
            <div key={lang} style={{
              display:"flex", justifyContent:"space-between",
              padding:"8px 0", fontSize:"0.875rem",
              color: live ? COLORS.textPrimary : COLORS.textMuted,
            }}>
              <span>{lang}</span>
              <span style={{ color: live ? COLORS.success : COLORS.textMuted, fontSize:"0.8125rem", fontWeight: live ? 600 : 400 }}>{status}</span>
            </div>
          ))}
          <div style={{ fontSize:"0.75rem", color: COLORS.textMuted, marginTop:"8px" }}>
            Your donations fund the corpus research for Telugu and Kannada.
          </div>
        </div>

        {/* Footer */}
        <div style={{ marginTop:"48px", paddingTop:"24px", borderTop:`1px solid ${COLORS.border}`, fontSize:"0.75rem", color: COLORS.textMuted }}>
          tamizh.fun · A VIRAT UK initiative · No tracking · No ads
        </div>
      </div>
    </div>
  );
}
